<template>
    <kiosk-team-details :teamId="props.teamId">
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full justify-center">
            <terms-list :teamId="props.teamId" />
        </div>
    </kiosk-team-details>
</template>

<script lang="ts" setup>
import KioskTeamDetails from '../details/KioskTeamDetails.vue';
import TermsList from './TermsList.vue';

const props = defineProps<{
    teamId: number;
}>();
</script>
